import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import React from 'react';
import { SectionWrapper } from './styled';

interface SectionListProps {
  title: string;
  children?: React.ReactNode;
}

function SectionList({ title, children }: SectionListProps) {
  return (
    <SectionWrapper>
      {/* @ts-expect-error */}
      <Text family="bold" mb="5px">
        {title}
      </Text>
      <Flex align="center">{children}</Flex>
    </SectionWrapper>
  );
}

export default SectionList;
